import React from 'react';

import { QBox, QStack, QText } from '@captivateiq/quotient';
import { BarChart, Histogram, LineChart, PieChart, ScatterPlot } from '@captivateiq/visualizations';

import type { ChartBlock } from '@captivateiq/assistant/types';

import {
  chartBlockToBarChartProps,
  chartBlockToHistogramProps,
  chartBlockToLineChartProps,
  chartBlockToPieChartProps,
  chartBlockToScatterPlotProps,
} from './chartBlockAdapter';

type Props = { block: ChartBlock };

const CHART_HEIGHT = 240;

export const ChartBlockRenderer = ({ block }: Props) => {
  const chart = (() => {
    switch (block.chartType) {
      case 'bar':
        return <BarChart {...chartBlockToBarChartProps(block)} />;
      case 'line':
        return <LineChart {...chartBlockToLineChartProps(block)} />;
      case 'pie':
        return <PieChart {...chartBlockToPieChartProps(block)} />;
      case 'scatter':
        return <ScatterPlot {...chartBlockToScatterPlotProps(block)} />;
      case 'histogram':
        return <Histogram {...chartBlockToHistogramProps(block)} />;
      default:
        return null;
    }
  })();

  if (chart === null) {
    return null;
  }

  return (
    <QBox
      sx={{
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: '8px',
        mb: 2,
        p: 2,
      }}
    >
      <QStack direction="column" spacing="8px">
        {block.title && <QText sx={{ color: 'grey.700', fontSize: '13px', fontWeight: 600 }}>{block.title}</QText>}
        <QBox sx={{ height: CHART_HEIGHT, width: '100%' }}>{chart}</QBox>
      </QStack>
    </QBox>
  );
};
